import * as types from '../const/action.types';
import { get, put, del } from '../api/_basic';

export function loadAlert(user) {
    return async (dispatch) => {
        dispatch(alertIsLoading(true));
        return get(`${process.env.REACT_APP_API_ALERT}/porusuario/${user}`)
            .then((response) => {
                dispatch(alertIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(loadAlertSuccess(items));
            })
            .catch((error) => {
                dispatch(alertIsLoading(false));
            });
    };
}

export function dismiss(id) {
    return async (dispatch) => {
        dispatch(alertIsSaving(true));
        return put(`${process.env.REACT_APP_API_ALERT}/${id}/dismiss`, {})
            .then((response) => {
                dispatch(alertIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(alertDismissSuccess(id));
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function deleteAlert(id) {
    return async (dispatch) => {
        dispatch(alertIsSaving(true));
        return del(`${process.env.REACT_APP_API_ALERT}/${id}`)
            .then((response) => {
                dispatch(alertIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(alertDeleteSuccess(id));
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function alertDeleteSuccess(id) {
    return {
        type: types.ALERTS_DELETE_SUCCESS,
        id,
    };
}

export function alertDismissSuccess(id) {
    return {
        type: types.ALERTS_DISMISS_SUCCESS,
        id,
    };
}

export function loadAlertSuccess(data) {
    return {
        type: types.LOAD_ALERTS_SUCCESS,
        data,
    };
}

export function alertIsLoading(bool) {
    return {
        type: types.ALERT_IS_LOADING,
        isLoading: bool,
    };
}

export function alertIsSaving(bool) {
    return {
        type: types.ALERT_IS_SAVING,
        isSaving: bool,
    };
}



// WEBPACK FOOTER //
// ./src/actions/alert.actions.js